module.exports = __webpack_public_path__ + "static/media/doc_browser_gray@3x.b6f5fef5.png";